import Repository from './Repository';
import {empty} from "../../shared/utils";

const resource = 'membership';
const resources = 'memberships?';

export default {
    get() {
        return Repository.get(resources + 'status[]=active&status[]=expired')
    },
    getMember(memberId) {
      return Repository.get(resource + '/' + memberId)
    },
    createMember(payload) {
        return Repository.post(resource, payload)
    },
    payMembership(memberId, sendMail) {
        return Repository.post(resource + '/' + memberId + '/pay', {
            'paymentSource': 'cash',
            'sendMail': sendMail
        })
    },
    cancelMembership(memberId) {
        return Repository.delete(resource + '/' +memberId + '/cancel')
    },
    searchMembership(searchForm) {
        let search = ''
        if (!empty(searchForm.status)) {
            search += '&status[]='+searchForm.status
        }

        if (!empty(searchForm.type)) {
            search += '&types[]='+searchForm.type
        }

        if (!empty(searchForm.id)) {
            search += '&ids[]='+searchForm.id
        }

        if (!empty(searchForm.personName)) {
            search += '&personName='+searchForm.personName
        }

        if (!empty(searchForm.personSurname)) {
          search += '&personSurname='+searchForm.personSurname
        }

        if (!empty(searchForm.personEmail)) {
          search += '&personEmails[]='+searchForm.personEmail
        }

        if (!empty(searchForm.limit)) {
          search += '&limit='+searchForm.limit
        }

        if (!empty(searchForm.page)) {
          search += '&page='+searchForm.page
        }

        return Repository.get(resources + search)
    },
}
